// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__1v0Ys","modal_header":"style_modal_header__GQzZP"};